import React from "react";
import FindingAPI from "restAPI/FindingAPI";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { SOURCE_TOOL_COLUMNS_FOR_WIDGET_OPTIONS } from "views/Dashboards/CustomDashboardConstants";

import ACMultiSelectCheckbox from "ac-components/ac-multi-select-checkbox";

import { FieldTypes } from "./formUtils";

export const getSourceToolColumnsSelectionField = () => {
  return {
    name: "sourceToolColumns",
    label: "Source Tool Columns",
    render: () => (
      <ACMultiSelectCheckbox options={SOURCE_TOOL_COLUMNS_FOR_WIDGET_OPTIONS} />
    ),
    // colSpan: 24,
  };
};
export const getSourceToolSelectionField = ({
  required = true,
  placeholder,
}: { required?: boolean; placeholder?: string } = {}) => {
  return {
    name: "sourceTools",
    label: "Select Source Tools",
    type: FieldTypes.SELECT,
    props: {
      api: ToolsIntegrationsAPI.getAppSecToolsStatus,
      mode: "multiple",
      maxTagCount: "responsive",
      allowClear: true,
      parseSelectOptions: toolsParseSelectOption,
    },
    required,
    placeholder,
    colSpan: 24,
  };
};
export const getScanTypeSelectionField = () => {
  return {
    name: "scanType",
    label: "Scan Type",
    type: FieldTypes.SELECT,
    props: {
      api: fetchScanTypes,
      allowClear: true,
      mode: "multiple",
      parseSelectOptions: (response: any) => {
        const scanTypes = response.scanType || [];
        return scanTypes.map((scanType: string) => ({
          label: scanType,
          value: scanType,
        }));
      },
    },
    // required: true,
    colSpan: 12,
  };
};

const fetchScanTypes = () => {
  return FindingAPI.getFilterValues({
    fields: ["scanType"],
  });
};

function toolsParseSelectOption(options: Array<{ toolName: string }>) {
  return options.map(({ toolName }) => ({ label: toolName, value: toolName }));
}

export enum SourceToolPivotTableDisplayAsOptionValue {
  NUMBER = "NUMBER",
  PERCENT = "PERCENT",
}

export const getSourceToolPivotTableDisplayAsOptions = () => {
  return [
    {
      label: "Number",
      value: SourceToolPivotTableDisplayAsOptionValue.NUMBER,
    },
    {
      label: "Percent",
      value: SourceToolPivotTableDisplayAsOptionValue.PERCENT,
    },
  ];
};

export enum SourceToolPivotTableGroupByOptionValue {
  FINDING_STATUS = "status",
}

export const getSourceToolPivotTableGroupByOptions = () => {
  return [
    {
      label: "Finding Status",
      value: SourceToolPivotTableGroupByOptionValue.FINDING_STATUS,
    },
  ];
};
